import { useModalStore } from '@/shared/lib';
import { MyDocumentsModal } from '../ui';

interface Props {
  onBack: () => void;
  isUserVerified: boolean;
}

const useMyDocumentsModal = () => {
  const { showDialogComponent } = useModalStore();

  const openMyDocumentsModal = ({ onBack, isUserVerified }: Props) => {
    showDialogComponent({
      component: (
        <MyDocumentsModal onBack={onBack} isUserVerified={isUserVerified} />
      ),
      className: 'bg-secondary-bg',
    });
  };

  return { openMyDocumentsModal };
};

export { useMyDocumentsModal };
